<template>
  <div class="section_header mobile_div section_gray_bg">
    <div class="row no-gutters mt-3 ">
      <div class="col-12 col-md-6">

          <router-link  :to="{name: 'project', params: { id: project.last_id }}"
                       class=" btn btn-sm ml-1 title_project_card text-truncate" tag="a">{{ project.name_project }}</router-link>

        <div class="card-body">
          <p class="card-text">Дата создания: {{ project.created_at }}</p>
          <p class="card-text">Дата обновления: {{ project.updated_at }}</p>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="card-body">
          <h5 class="card-title" v-if="project.manage_spectator==0 && project.developer">Исполнитель: {{ project.developer.name}}</h5>
          <p class="card-text" v-if="project.status_row && project.status_row.issearch==1 && project.offers_count">Предложений ({{ project.offers_count }})</p>
          <p class="card-text" v-if="project.datetime_client">
            <b>Дата записи</b> {{ project.datetime_client }}
          </p>
          <p class="card-text" v-if="project.status_row && project.status_row.issearch==1 && project.my_offers_count && project.my_offers_count>0"><i class="fa fa-check-circle" title="вы уже отправили предложение"></i>&nbsp; отправлено</p>
          <p class="card-text" v-if="project.manage_spectator==0 && project.client">Клиент: {{ project.client.name}}</p>
          <p class="card-text" v-if="project.service && project.service.name">{{ project.service.name}}</p>
          <p class="card-text" v-if="project.main_project_id==0">Статус проекта: {{ project.status_row.title}}</p>
          <p class="card-text" v-if="project.main_project_id>0">Статус задачи: {{ project.status_row.title}} </p>
        </div>
      </div>
    </div>
    <div class="card-footer mb-3  ">
      <div class="row">
        <div class="col-6 col-md-6 mt-2 mb-2">
          <router-link v-if="(project.status_row.issearch==0 && project.main_project_id==0) && project.manage_spectator==1  " class="btn btn-sm" :to="{name: 'add_task',params:{id:project.last_id}}"><i class="fa fa-plus"></i> задача</router-link>
        </div>
        <div class="col-6 col-md-6  mt-2 mb-2 text-right">
          <router-link v-if="project.main_project_id==0" :to="{name: 'project', params: { id: project.last_id }}"
              class="btn btn-sm" tag="a">Перейти</router-link>
          <router-link v-if="project.main_project_id!=0" :to="{name: 'project', params: { id: project.last_id }}"
              class="btn btn-sm" tag="a">Перейти</router-link>
        </div>
      </div>


    </div>
  </div>

</template>

<script>
export default {
  name: 'ProjectCard',
  props: {
    project: Object,
    nightMode: Boolean
  },
  computed: {
    cardClass() {
      return this.nightMode ? '_night' : '';
    }
  }
}
</script>

<style scoped>
.card {
  margin-bottom: 1rem;
}

.card-header {
  /*background-color: #f8f9fa;*/
}

.card-body {
  /*background-color: #fff;*/
}

.card._night .card-header {
  /*background-color: #343a40;*/
}

.card._night .card-body {
  /*background-color: #212529;*/
}
</style>